module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6g4nw4/tc-custom/9781455605231.jpg?1703907396885",
      "alt": "This image is the cover for the book Governors of Texas, Governors"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Governors of Texas, Governors\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The state of Texas holds an interesting and important place in the history of the United States, and this volume explores those men and women who have helped to shape the course of the state by serving as governor.")]), _c('p', [_vm._v("For example, Miriam V. Ferguson (1925-1927, 1933-1935) was the first woman governor of the state. She won the governorship by promising that she would work with her husband, former Texas governor, James E. \"Farmer Jim\" Ferguson (1915-1917), assuring Texans that they would have \"two governors for the price of one.\"")]), _c('p', [_vm._v("As in the story of the Fergusons, The Governors of Texas offers political and biographical information on each Texas governor from the period of French control through 1973. Thus the progression towards statehood and beyond is clearly visible in this history of the individuals who took great pride in serving as their state's chief executive officer.")]), _c('p', [_vm._v("For quick reference, a roster of governors is also provided, giving full names and the dates in which each individual held office. Also included are pictures of most of the governors, so that these men and women may be more vividly brought to life.")]), _c('p'), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ross Phares\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ross Phares is also the author of Texas Tradition [pb (F)], Cavalier in the Wilderness [pb (F)], and Reverend Devil: Master Criminal of the Old South [pb(F)], all of which are published by Pelican. He is a native of Shreveport, Louisiana.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pelican Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0